<section class="discount-offer-information">
    <h3 class="title">{{ title }}</h3>
    <div class="description" [innerHTML]="description | markdownToSafeHTML"></div>
</section>
